const specials = [
  {
    regNum: 303,
    item: "black cod",
    desc: "butterfish"
  },
  {
    regNum: 304,
    item: "yellowtail collar",
    desc: "hamachi kama"
  },
  {
    regNum: 305,
    item: "stuffed peppers",
    desc: "green peppers stuffed with ground pork"
  },
  {
    regNum: 306,
    item: "kobe beef sliders",
    desc: "mini hamburger slider"
  },
  {
    regNum: 307,
    item: "stuffed shiitake mushrooms",
    desc: "shiitake mushrooms stuffed with ground pork"
  },
  {
    regNum: 308,
    item: "australian lamb",
    desc: "garlic or no garlic"
  },
  {
    regNum: 309,
    item: "tomato maki",
    desc: "tomato wrapped with shiso leaf - 1 tomato cut in half (1 skewer)"
  },
  {
    regNum: 311,
    item: "garlic",
    desc: ""
  },
  {
    regNum: 312,
    item: "potato",
    desc: "with sour cream or without"
  },
  {
    regNum: 313,
    item: "corn",
    desc: "shaved or on the cob"
  },
  {
    regNum: 314,
    item: "onion",
    desc: "shio or tare"
  },
  {
    regNum: 315,
    item: "colored pepper",
    desc: ""
  },
  {
    regNum: 317,
    item: "pork belly",
    desc: "shio or tare"
  },
  {
    regNum: 318,
    item: "pork sausage",
    desc: "regular or spicy"
  },
  {
    regNum: 319,
    item: "baby zucchini",
    desc: ""
  },
  {
    regNum: 320,
    item: "brussel spouts",
    desc: "mei kyabetsu"
  },
  {
    regNum: 321,
    item: "duck",
    desc: ""
  },
  {
    regNum: 323,
    item: "chicken oyster",
    desc: "dark meat"
  }   
]

export default specials;